module.exports = __webpack_public_path__ + "img/ComingSoon2.c7f9767b.png";